import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { useGetSummaryList } from './useGetSummaryList';

export type UseRateSummaryPayload = {
  summary_id: string;
  score: number;
  comment: string;
};

export const useRateSummary = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rateSummary'],
    mutationFn: (payload: UseRateSummaryPayload) =>
      ambientApi.post(`/summary_feedback`, payload).then((res) => res.data),
    onSuccess: (_, payload) => {
      queryClient.setQueriesData<ReturnType<typeof useGetSummaryList>['data']>(
        { queryKey: ['summaryList'] },
        (oldData) => {
          if (!oldData) return oldData;

          return {
            ...oldData,
            summaries: oldData?.summaries?.map((summary) =>
              summary.summary_id === payload.summary_id
                ? { ...summary, summary_ratings: payload.score }
                : summary
            ),
          };
        }
      );
    },
  });
};
